import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { UserState } from '../../../store/user/user.model';
import { logout } from '../../../store/user/user.actions';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class UserProfileComponent {
  userInfo$: Observable<{ name: string; familyName: string; email: string } | null>;

  constructor(private router: Router,private store: Store<{ user: UserState }>) {
    this.userInfo$ = this.store.select(state => state.user.userInfo);
  }

  logout() {
    this.store.dispatch(logout());
    this.router.navigate(['/login']);
  }
}
